import { useState } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import ThreadCardHeader from './thread-card-header';
import AttachmentIndicator from '../../components/indicators/attachment-indicator';

const ThreadCard = ({ email, isLastEmail }) => {
  const [isExpanded, setIsExpanded] = useState(isLastEmail);

  const toggleExpansion = (e) => {
    // Check if click originated from an interactive element
    const isInteractiveElement = e.target.closest(
      'button, a, input, select, textarea, [role="button"], [role="menuitem"], .et--link, .et--actions-menu, .outreach-card-recipient-name'
    );

    if (isInteractiveElement) {
      return; // Don't handle the click if it's on an interactive element
    }

    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="email-card">
      <div className="email-card-main">
        <div className="email-card-content" onClick={toggleExpansion}>
          <ThreadCardHeader email={email} />
          <div className="email-card-body-wrapper">
            {!isExpanded ? (
              <p className="email-card-body-preview">{email.parsed_body}</p>
            ) : (
              <div className="email-card-body-content">{ReactHtmlParser(email.body)}</div>
            )}
          </div>
          <hr className="email-card-divider" />
          <div className="outreach-card-tab-group">
            {email?.email_attachments?.length > 0 &&
              email.email_attachments.map((attachment, index) => (
                <AttachmentIndicator key={attachment.content_id || index} attachment={attachment} />
              ))}
          </div>
        </div>
      </div>

      {!isLastEmail && <hr className="email-card-divider" />}
    </div>
  );
};

ThreadCard.propTypes = {
  email: PropTypes.object,
  isLastEmail: PropTypes.bool,
};

export default ThreadCard;
